import { useContext } from "react";
import { AppContext } from "contexts/AppContext";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Headline3 from "components/elements/Headline3";
import ContentNormal from "components/elements/ContentNormal";
import BannerSection from "components/blocks/bannerSection/bannerSection";
import ButtonMedium4 from "components/elements/ButtonMedium4";

const FrontPageFaqSection = () => {
    const navigate = useNavigate()
    const { brandData, styleGuide } = useContext(AppContext);
    const { frontPageFaqImageUrl, frontPageFaqBackgroundColor, frontPageFaqTextColor} = brandData && brandData.features

    const backgroundColor = frontPageFaqBackgroundColor || styleGuide.color3
    const textBackgroundColor = styleGuide.color14
    const textColor = frontPageFaqTextColor || styleGuide.color7

    return (
        <BannerSection bannerImageUrl={frontPageFaqImageUrl} backgroundColor={backgroundColor} backgroundHeightPct={80} textBackgroundColor={textBackgroundColor}>
            <Box flex={1} display={'flex'} justifyContent={{xs: 'left', md: 'center'}} padding={{xs: '20px 20px 40px 20px', sm: '32px 32px 48px 32px', md: 6, xl: 10}}>
                <Box display={'flex'} flexDirection={'column'} gap={2} paddingBottom={6}>
                    <Box display={'flex'} flexDirection={'column'} gap={1}>
                        <ContentNormal
                            style={{color: textColor}}
                            translationKey="_FRONT_PAGE_FAQ_SECTION_BODY_"
                            fallbackText="Har du spørgsmål?"
                        />
                        <Headline3
                            style={{color: textColor}}
                            translationKey="_FRONT_PAGE_FAQ_SECTION_BODY_"
                            fallbackText="Vi er altid klar til at hjælpe"
                        />
                    </Box>
                    <Box display={'flex'} flexWrap={'wrap'} gap={2}>
                        <ButtonMedium4
                            translationKey={'_READ_FAQ_'}
                            fallbackText={'Læs FAQ'}
                            showIcon={false}
                            onClick={() => {
                                navigate('/help')
                            }}
                            color={textColor}
                        />
                        <ButtonMedium4
                            translationKey={'_CONTACT_US_'}
                            fallbackText={'Kontakt os'}
                            showIcon={false}
                            onClick={() => {
                                navigate('/contact')
                            }}
                            color={textColor}
                        />
                    </Box>
                </Box>
            </Box>
        </BannerSection>
    )
}

export default FrontPageFaqSection